export const CSRF_TOKEN_HEADER = 'x-csrf-token';
export const CSRF_TOKEN_FIELD = 'crrCSRFToken';
